import createSelector from 'utils/redux/createSelector' // import { createSelector } from 'reselect'
import * as R from 'ramda'
import moment from 'moment'
import { makePropSelector } from './common'
import { comments } from './entities'
import { commentsByObjectID } from './index'

export let objectComments = createSelector(
	[commentsByObjectID, makePropSelector('objectID')]
  , (commentsByObjectID, objectID) => {
		return R.pipe(
			R.sortBy(x => moment(x.updatedAt || x.createdAt))
		  , R.reverse
		)(commentsByObjectID[objectID] || [])
	}
)



// WEBPACK FOOTER //
// ./src/selectors/comments.js